import { render } from "./Destinations.vue?vue&type=template&id=3464438c"
import script from "./Destinations.vue?vue&type=script&lang=js"
export * from "./Destinations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Destinations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3464438c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3464438c', __exports__)) {
    api.reload('3464438c', __exports__)
  }
  
  module.hot.accept("./Destinations.vue?vue&type=template&id=3464438c", () => {
    api.rerender('3464438c', render)
  })

}


export default __exports__